import React, { useEffect, useState } from "react";
import {
  Button,
  Table,
  Container,
  Row,
  Col,
  Dropdown,
  Pagination,
} from "react-bootstrap";
import DirectoryModal from "../components/Directory/Modal/addDirectoryModal";
import DirectoryEditModal from "../components/Directory/Modal/editDirectoryModal";
import DirectoryContactDeleteModal from "../components/Directory/Modal/deleteDirectoryContactModal";
import BulkAddDirectoryModal from "../components/Directory/Modal/bulkAddDirectoryModal";
import { useDispatch, useSelector } from "react-redux";
import { getDepartments, getDirectory } from "../Redux/Directory/action";
import "../assets/css/directory.css";

export default function Directory() {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [bulkAddModal, setBulkAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteDirectoryContactModal, setDeleteDirectoryContactModal] =
    useState(false);
  const [selectedDirectory, setSelectedDirectory] = useState(null);
  const [selectedDirectoryContactID, setSelectedDirectoryContactID] =
    useState(null);
  const [directoryData, setDirectoryData] = useState(
    useSelector((state) => state.directoryReducer?.directory),
  );
  const user = useSelector((state) => state.authReducer?.data);
  const [selectedDepartment, setSelectedDepartment] = useState("All");
  const accountID = user?.accountID;
  const directory = useSelector((state) => state.directoryReducer?.directory);
  const directoryDepartments = useSelector(
    (state) => state?.directoryReducer?.departments,
  );
  let initialItemsPerPage = 10;
  const [itemsPerPage, setItemsPerPage] = useState(initialItemsPerPage);
  const totalItems = directory?.totalResults;
  const allPages = directory?.totalPages;
  const [currentPage, setCurrentPage] = useState(1);
  const handleShowModal = () => setShowModal(true);
  const handleShowBulkAddModal = () => setBulkAddModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleCloseBulkAddModal = () => {
    setBulkAddModal(false);
  };
  const handleShowEditModal = (directory) => {
    setSelectedDirectory(directory);
    setShowEditModal(true);
  };
  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedDirectory(null);
  };
  const handleShowDeleteDirectoryContactModal = (directory) => {
    setSelectedDirectoryContactID(directory?.id);
    setDeleteDirectoryContactModal(true);
  };
  const handleCloseDeleteDirectoryContactModal = () => {
    setDeleteDirectoryContactModal(false);
    setSelectedDirectory(null);
  };
  const handleSelect = (value) => {
    setItemsPerPage(Number(value));
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDepartmentChange = (department) => {
    setSelectedDepartment(department);
    setCurrentPage(1);
    setItemsPerPage(initialItemsPerPage);
  };

  useEffect(() => {
    async function fetchData() {
      await getDirectory(
        dispatch,
        accountID,
        selectedDepartment,
        itemsPerPage,
        currentPage,
      );
    }

    fetchData();
  }, [currentPage, itemsPerPage, selectedDepartment]);

  useEffect(() => {
    async function fetchData() {
      await getDepartments(dispatch, accountID);
    }

    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      if (directory) {
        await getDepartments(dispatch, accountID);
        setDirectoryData(directory);
      }
    }

    fetchData();
  }, [directory]);

  return (
    <Container fluid>
      <Row className="mt-5 m-0 p-0">
        <Col md={12}>
          <Row
            className={"d-flex mt-4 justify-content-between align-items-center"}
          >
            <h1 className="main-h4-tag-large">Directory</h1>
            <div>
              <Button
                variant="primary"
                type="submit"
                className="custom-button m-2"
                onClick={handleShowBulkAddModal}
              >
                Bulk Add
              </Button>
              <Button
                variant="primary"
                type="submit"
                className="custom-button"
                onClick={handleShowModal}
              >
                Add Staff
              </Button>
            </div>
          </Row>
          {directoryDepartments?.length ?
          <div className="border rounded overflow-hidden">
            <div className="bg-light p-3 d-flex justify-content-between align-items-center">
              <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                <Button
                  variant="link"
                  className={`text-muted mr-2 ${
                    selectedDepartment === "All" && "active"
                  }`}
                  onClick={() => handleDepartmentChange("All")}
                >
                  All
                </Button>
                {directoryDepartments?.length > 0 &&
                  directoryDepartments?.map((department) => (
                    <Button
                      key={department}
                      variant="link"
                      className={`text-muted mr-2 ${
                        selectedDepartment === department && "active"
                      }`}
                      onClick={() => handleDepartmentChange(department)}
                    >
                      {department}
                    </Button>
                  ))}
              </div>
            </div>
            <div className={"m-2"}>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Department</th>
                    <th>Date Added</th>
                    <th className="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {directoryData?.results?.map((directory) => (
                    <tr key={directory?.id}>
                      <td>
                        <div className="d-flex align-items-center">
                          <span>{directory?.name}</span>
                        </div>
                      </td>
                      <td>{directory?.phone}</td>
                      <td>{directory?.email}</td>
                      <td>{directory?.department}</td>
                      <td>{new Date(directory?.createdAt).toLocaleString()}</td>
                      <td className="text-right">
                        <Dropdown drop={"start"}>
                          <Dropdown.Toggle
                            size="sm"
                            style={{ background: "#172E57" }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3" />
                              <path d="M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3" />
                              <path d="M4 12H2" />
                              <path d="M10 12H8" />
                              <path d="M16 12h-2" />
                              <path d="M22 12h-2" />
                            </svg>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className={"border"}>
                            <Dropdown.Item
                              className="directory-dropdown-item"
                              onClick={() => handleShowEditModal(directory)}
                            >
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="directory-dropdown-item"
                              onClick={() =>
                                handleShowDeleteDirectoryContactModal(directory)
                              }
                            >
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="bg-light d-flex mt- justify-content-between align-items-center">
              <div className=" ml-3" style={{ color: "#172E57" }}>
                Showing{" "}
                {currentPage * Math.min(itemsPerPage, totalItems) > totalItems
                  ? totalItems
                  : currentPage * Math.min(itemsPerPage, totalItems)}{" "}
                of {totalItems} contacts
              </div>
              <div>
                <Pagination>
                  <Pagination.First
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                  />
                  <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  />
                  {currentPage > 2 && <Pagination.Ellipsis />}
                  {Array(allPages)
                    .fill(0)
                    .map((_, index) => {
                      const pageNumber = index + 1;
                      const isCurrentPage = pageNumber === currentPage;

                      if (
                        pageNumber === 1 ||
                        pageNumber === allPages ||
                        (pageNumber >= currentPage - 2 &&
                          pageNumber <= currentPage + 2)
                      ) {
                        return (
                          <Pagination.Item
                            key={pageNumber}
                            onClick={() => handlePageChange(pageNumber)}
                            style={{
                              backgroundColor: isCurrentPage
                                ? "#172E57"
                                : "white",
                              color: isCurrentPage ? "white" : "black",
                            }}
                          >
                            {pageNumber}
                          </Pagination.Item>
                        );
                      }
                    })}
                  {currentPage < allPages - 1 && <Pagination.Ellipsis />}
                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === allPages}
                  />
                  <Pagination.Last
                    onClick={() => handlePageChange(allPages)}
                    disabled={currentPage === allPages}
                  />
                </Pagination>
              </div>
              <div>
                <Dropdown className="mr-3">
                  <Dropdown.Toggle
                    variant="secondary"
                    id="dropdown-basic"
                    style={{ background: "#172E57" }}
                  >
                    Show {itemsPerPage}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      className="directory-dropdown-item"
                      onClick={() => handleSelect("10")}
                    >
                      Show 10
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="directory-dropdown-item"
                      onClick={() => handleSelect("20")}
                    >
                      Show 20
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="directory-dropdown-item"
                      onClick={() => handleSelect("50")}
                    >
                      Show 50
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="directory-dropdown-item"
                      onClick={() => handleSelect("100")}
                    >
                      Show 100
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>:
              (<h6 style={{height:'65vh',color:'red'}} className={"text-center mt-5"}>No Directory Data</h6>)}
        </Col>
      </Row>
      <DirectoryModal show={showModal} onHide={handleCloseModal} />
      <DirectoryEditModal
        show={showEditModal}
        onHide={handleCloseEditModal}
        directory={selectedDirectory}
      />
      <DirectoryContactDeleteModal
        show={showDeleteDirectoryContactModal}
        onHide={handleCloseDeleteDirectoryContactModal}
        directoryContactID={selectedDirectoryContactID}
      />
      <BulkAddDirectoryModal
          show={bulkAddModal}
          onHide={handleCloseBulkAddModal}
          setBulkAddModal={setBulkAddModal}
      />
    </Container>
  );
}
